'use client'

import { Button } from '@/components/ui/button'
import { Chip } from '@/components/ui/chip'
import { Icon } from '@/components/ui/icon'

import { useContentEdit } from './content-edit-provider'

/**
 * Floating edit-mode switch. Mounted by ContentEditProvider only while the
 * status route reports the gate open, so it never renders on production.
 *
 * Bottom-left placement clears the booking FAB and the bottom nav, which both
 * sit bottom-right / bottom-centre.
 */
export function ContentEditToolbar() {
  const { editing, setEditing, pending } = useContentEdit()

  return (
    <div data-testid='content-edit-toolbar' className='fixed bottom-24 left-4 z-50 flex items-center gap-2'>
      <Button
        variant={editing ? 'primary' : 'secondary'}
        size='sm'
        className='min-h-11 rounded-full shadow-lg'
        onPress={() => setEditing(!editing)}
        aria-pressed={editing}
        aria-label={editing ? 'Stop editing content' : 'Edit content'}
      >
        <Icon icon='edit' className='text-base' />
        {editing ? 'Editing' : 'Edit'}
      </Button>
      {pending > 0 ? (
        <Chip color='warning' size='sm'>
          {pending} to pull
        </Chip>
      ) : null}
    </div>
  )
}
